import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';
import updateEntityRecord from '../helpers/services/update-entity-record';

const useUpdateEntityRecord = entitySchema => {
  const client = useApolloClient();

  return useCallback(
    input => updateEntityRecord(client, entitySchema, input),
    [client, entitySchema]
  );
};

export default useUpdateEntityRecord;
